
// SearchResult.jsx
import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Divider } from '@mui/material';
import { AdsClickOutlined } from '@mui/icons-material';
import { fetchSideEffects } from '../../../api';

const SearchResult = ({ result }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [sideEffects, setSideEffects] = React.useState(null);
  const [loadingSideEffects, setLoadingSideEffects] = React.useState(false);
  const [errorSideEffects, setErrorSideEffects] = React.useState(null);

  const handleExpandClick = () => {
    setExpanded((prev) => !prev);
  };

  const handleSideEffectsClick = async () => {
  setLoadingSideEffects(true);
  setErrorSideEffects(null);
  setSideEffects(null);

  try {
    const { data } = await fetchSideEffects(result.genericName);
    setSideEffects(data.sideEffects);
  } catch (e) {
    setErrorSideEffects(e.response?.data?.message || e.response?.data?.error || e.message);
  } finally {
    setLoadingSideEffects(false);
  }
};

const DETAIL_FIELDS = [
  { key: 'regNo',            label: 'Reg. No' },
  { key: 'dossierNo',        label: 'Dossier No.' },
  { key: 'dosageCode',       label: 'Strength / Dose' },
  { key: 'packType',         label: 'Pack Type' },
  { key: 'packSize',         label: 'Pack Size' },
  { key: 'manuCode',         label: 'Manufacturer' },
  { key: 'countryCode',      label: 'Country' },
  { key: 'localAgentCode',   label: 'Local Agent' },
  { key: 'schedule',         label: 'Schedule' },
  { key: 'dateRegistration', label: 'Date of Registration' },
  { key: 'validityPeriod',   label: 'Validity Period' },
];



  return (
    <Card
      sx={{
        maxWidth: '100%',
        position: 'relative',
        boxShadow: 'none',
        borderRadius: '16px',
        border: '1px solid #ddd',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection:'column', justifyContent: 'center' }}>
          <Typography variant="subtitle2" sx={{ color: '#059669', fontWeight: 'bold' }}>
            {result.brandName}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: '#3898ec', fontWeight: 'bold' }}>
            {result.genericName}
          </Typography>
        </div>

        {/* Side Effects Button */}
        <div style={{display:'flex', flexDirection:'column', marginLeft:'auto'}}>

        <IconButton
          sx={{
            backgroundColor: '#ffeaee',
            borderRadius: '50%',
            p: 1,
            marginRight: '5px',
            marginBottom:'5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleSideEffectsClick}
        >
          <AdsClickOutlined sx={{ color: 'error.light', fontSize: 20 }} />
        </IconButton>
        <IconButton
          sx={{
            backgroundColor: '#ededed',
            borderRadius: '50%',
            p: 1,
            marginRight:'5px',
            marginTop:'5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'transform 0.5s ease-in-out',
    transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon sx={{fontSize: 20 }} />
        </IconButton>
        </div>
      </CardContent>

      {/* Display loading, error, or side effects text */}
      {loadingSideEffects && (
        <CardContent>
          <Typography variant="body2">Loading side effects...</Typography>
        </CardContent>
      )}
      {errorSideEffects && (
        <CardContent>
          <Typography variant="body2" color="error">
            {errorSideEffects}
          </Typography>
        </CardContent>
      )}
      {sideEffects && (
        <CardContent sx={{paddingTop:'0'}}>
          <Divider />
          <ul style={{ padding: '16px', margin: 0 }}>
            {sideEffects.map((effect, index) => (
              <li key={index}>
                <Typography variant="subtitle2" style={{fontWeight:'normal'}}>{effect}</Typography>
              </li>
            ))}
          </ul>
          <Divider />
          <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', mb: 1, mt:2, fontSize:'12px', textAlign:'center' }}
            >
              
              Demo shows examples only. Create a MediCheck account to view real side effects.
            </Typography>
        </CardContent>
        
      )}

      {/* Collapsible extra info */}
      <Collapse in={expanded} timeout={500}>
  <CardContent>
    <Divider />
    <ul style={{ padding: '16px', margin: 0, listStyleType: 'none' }}>
      {DETAIL_FIELDS.map(({ key, label }) => {
        const value = result?.[key];
        if (!value) return null; // skip empty fields

        // optional: simple date formatting for dateRegistration
        const displayValue =
          key === 'dateRegistration'
            ? new Date(value).toLocaleDateString('en-GB') // 24/01/2026 style
            : value;

        return (
          <li key={key} style={{ marginBottom: 4 }}>
            <Typography variant="body2">
              <span style={{ fontWeight: 'bold' }}>{label}: </span>
              {displayValue}
            </Typography>
          </li>
        );
      })}
    </ul>
  </CardContent>
</Collapse>

    </Card>
  );
};

export default SearchResult;
